import React, {Component} from "react";
import Constants from "../../../constants/constants";

import withStaticImages from "../../../services/utils/imageNameRetriever";

const gameIconStyle = {
    width: "125px"
};

const gameIconContainer = {
    "display": "inline-block",
};


class GameIcon extends Component {
    render() {
        const {game, player_id, user, isLink} = this.props;
        const _style = this.props.gameIconStyle || gameIconStyle;

        const linkProps = {};
        if (isLink) {
            let port = window.location.port;

            let platformURL = "https://" + window.location.hostname;

            if (port !== "") {
              platformURL += ":" + port;
            }

            platformURL = encodeURIComponent(platformURL);
            const url = `${Constants.getPlayContentUrl()}/play_game?game_id=${game.id}&player_id=${player_id}&auth=${user.token}&purl=${platformURL}`;
            linkProps.href = url
        }

        const gameIcon = this.gameIcon(_style);
        return isLink ? <a {...linkProps}>{gameIcon}</a> : gameIcon
    }

    gameIcon(_style) {
        const {game, iconClassName, showName} = this.props;

        const onClick = this.props.onClick;

        if (!game || !Object.keys(game) || Object.keys(game).length === 0) {
            return <div className='icon_not_available'>N/A</div>;
        }

        return <div className="game_icon_container"
                    style={gameIconContainer}
                    id={game.id}>
            <img style={_style}
                 src={this.props.getImage(game.image_path)}
                 alt={game.image_filename}
                 onClick={onClick}
                 className={iconClassName}
            />
            {showName &&
            <p className="mx-0 mt-1 mb-0 p-0 small text-secondary text-center">{game.name}</p>
            }
        </div>;
    }
}

export default withStaticImages('game_icons',GameIcon);



// WEBPACK FOOTER //
// ./src/components/components/game-icon/game-icon.js